import { Controller } from '@hotwired/stimulus';
import Swal from 'sweetalert2';
import { useUtilities } from './mixins/utilities';
import { useRequests } from './mixins/requests';

export default class extends Controller {
  static targets = ['modal', 'form', 'modalContent', 'submit'];

  connect() {
    useUtilities(this);
    useRequests(this);
  }

  async submit(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    if (this.submitting) return;

    const form = this.formTarget;
    this.setSubmitting(true);

    try {
      const data = await this.fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
      });

      if (data.error || typeof data.html !== 'string') {
        throw new Error('Unexpected phone form response');
      }

      if (data.success) {
        this.modalContentTarget.outerHTML = data.html;
        this.saved = true;
      } else {
        form.outerHTML = data.html;
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Enregistrement impossible',
        text: 'Tes informations ont été conservées. Réessaie dans quelques instants.',
        confirmButtonText: 'Fermer',
      });
    } finally {
      this.setSubmitting(false);
    }
  }

  setSubmitting(submitting) {
    this.submitting = submitting;
    if (this.hasFormTarget) this.formTarget.setAttribute('aria-busy', String(submitting));
    this.submitTargets.forEach((button) => {
      button.disabled = submitting;
    });
  }

  toggle(evt) {
    evt.preventDefault();

    if (this.saved) {
      window.location.reload();
      return;
    }

    this.toggleAll(
      this.modalTarget,
      ['opacity-0', 'opacity-100', 'pointer-events-none', 'pointer-events-auto', '-z-1', 'z-20']
    );
  }
}
